import { Component, OnInit, TemplateRef } from "@angular/core";
import { ListService } from "../../../../auth/service/list.service";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ICustomerType } from "../../customer.interface";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../auth/service";

@Component({
  selector: "app-fte-subject",
  templateUrl: "./fte-subject.component.html",
})
export class FteSubjectComponent implements OnInit {
  public contentHeader: IContentHeader;
  private list_type: string = "fte_subject_type";
  private customerTypeList = [];
  public filteredTypesList = [];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public showModalError: boolean = false;
  public typeForm: Partial<ICustomerType> = {
    id: null,
    name: null,
    other: {
      code: null,
    },
  };

  constructor(
    public listService: ListService,
    private _routerService: Router,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _modalService: NgbModal,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.CUSTOMERS_FTE_SUBJECT_TYPE_PLURAL",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.CUSTOMERS",
            isLink: false,
          },
          {
            name: "MENU.CUSTOMERS_FTE_SUBJECT_TYPE_PLURAL",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_customer_subject_types_list")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    this.load();
  }

  load() {
    this.listService.getList(this.list_type).then((result: ICustomerType[]) => {
      this.customerTypeList = result;
      this.filterTypes();
    });
  }

  modalOpen(modal: TemplateRef<any>, selectedType: ICustomerType | undefined = undefined) {
    this._modalService.open(modal, {
      size: "md",
      centered: true,
    });
    this.typeForm = {
      id: null,
      name: "",
      other: {
        code: "",
      },
    };
    if (selectedType) {
      this.typeForm = selectedType;
    }
    this.showModalError = false;
  }

  filterTypes() {
    const key: string = this.searchKeyword.trim().toLowerCase();
    let filterItem: ICustomerType[] = this.customerTypeList;
    if (key.length > 0) {
      filterItem = filterItem.filter((item: ICustomerType) => item.name.toLowerCase().trim().includes(key));
    }
    this.filteredTypesList = filterItem;
  }

  isError(): boolean {
    this.showModalError = this.typeForm.name === null || this.typeForm.name.length < 1 || this.typeForm.other.code === null || this.typeForm.other.code.length < 1;
    return this.showModalError;
  }

  async addType() {
    if (!this._authenticationService.hasCapability("create_fte_subject_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    delete this.typeForm.id;

    this._utilService.showLoading();
    await this.listService
      .create(this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_ADD_FTE_SUBJECT_TYPE");
        this.typeForm = {
          id: null,
          name: "",
          other: {
            code: "",
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_ADD_FTE_SUBJECT_TYPE");
      });
  }

  async editType() {
    if (!this._authenticationService.hasCapability("edit_fte_subject_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const idType: number = this.typeForm.id;
    delete this.typeForm.id;
    delete this.typeForm.type;

    this._utilService.showLoading();
    await this.listService
      .update(idType, this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_EDIT_FTE_SUBJECT_TYPE");
        this.typeForm = {
          id: null,
          name: "",
          other: {
            code: "",
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_EDIT_FTE_SUBJECT_TYPE");
      });
  }

  async deleteType(selectedType: any) {
    if (!this._authenticationService.hasCapability("delete_fte_subject_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selectedType.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.listService.delete(selectedType.id, this.list_type).then(() =>
            this._utilService.showPopupItemDeleted().then(async () => {
              this.load();
              await this._utilService.showToastrSuccess("SUCCESS_DELETE_FTE_SUBJECT_TYPE");
            }),
          );
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showToastrError("ERROR_DELETE_FTE_SUBJECT_TYPE"));
  }
}
